/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewladderstep1detail4Inputs */

const en_letterpreviewladderstep1detail4 = /** @type {(inputs: Letterpreviewladderstep1detail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today — opens a written record`)
};

const pt_letterpreviewladderstep1detail4 = /** @type {(inputs: Letterpreviewladderstep1detail4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje — abre um registo escrito`)
};

/**
* | output |
* | --- |
* | "Today — opens a written record" |
*
* @param {Letterpreviewladderstep1detail4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewladderstep1detail4 = /** @type {((inputs?: Letterpreviewladderstep1detail4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewladderstep1detail4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewladderstep1detail4(inputs)
	return pt_letterpreviewladderstep1detail4(inputs)
});
export { letterpreviewladderstep1detail4 as "letterPreviewLadderStep1Detail" }